const supportedLocales = {
  en_GB: 'en_GB',
};

export default supportedLocales;
